import { render, staticRenderFns } from "./MyPromotion.vue?vue&type=template&id=0266a187&scoped=true"
import script from "./MyPromotion.vue?vue&type=script&lang=js"
export * from "./MyPromotion.vue?vue&type=script&lang=js"
import style0 from "./MyPromotion.vue?vue&type=style&index=0&id=0266a187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266a187",
  null
  
)

export default component.exports